<template>
    <div class="flex flex-col h-full gap-2 p-2">
        <local-grid ref="userGridRef" :meta="meta" :data-source="displayList">
            <template #toolbarItems>
                <dx-item widget="dxButton" location="after" show-text="inMenu" locate-in-menu="auto">
                    <dx-button class="ai-button-base" hint="Обновить данные" @click="updateGridData">
                        <ai-refresh-base />
                    </dx-button>
                </dx-item>
                <dx-item widget="dxDropDownButton" location="after" show-text="inMenu" locate-in-menu="auto">
                    <dx-drop-down-button
                        icon='<svg width="32" height="32" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle class="ai-svg-back-base" cx="60" cy="60" r="60" fill="white"/>
<rect class="ai-svg-path-base" x="56" y="27" width="8" height="66" rx="2" fill="#286EB6"/>
<rect class="ai-svg-path-base" x="93" y="56" width="8" height="66" rx="2" transform="rotate(90 93 56)" fill="#286EB6"/>
</svg>'
                        displayExpr="name"
                        hint="Добавить пользователя"
                        :disabled="disableUiElement({ id: 721 })"
                        :items="[
                            {
                                id: 1,
                                name: 'Добавить пользователя',
                                onClick: onAddNewUser,
                            },
                            {
                                id: 2,
                                name: 'Создать пользователя из ActiveDirectory',
                                onClick: createUserFromActiveDirectory,
                            },
                        ]"
                        :dropDownOptions="{ width: 400 }"
                    />
                </dx-item>
                <dx-item widget="dxButton" location="after" show-text="inMenu" locate-in-menu="auto">
                    <dx-button
                        class="ai-button-base"
                        hint="Удалить пользователя"
                        icon="trash"
                        :disabled="disableUiElement({ id: 722 }) || isSelectedItemKeys || isCurrentUserStatusDeleted"
                        @click="deleteSelectedUsers"
                    >
                        <ai-delete-base />
                    </dx-button>
                </dx-item>
                <dx-item widget="dxButton" location="after" show-text="inMenu" locate-in-menu="auto">
                    <dx-button
                        class="ai-button-base"
                        hint="Массовая блокировка"
                        :disabled="disableUiElement({ id: 1082 }) || isSelectedItemKeys"
                        @click="massLockClick"
                    >
                        <ai-mass-lock />
                    </dx-button>
                </dx-item>
                <dx-item location="before" name="custom-filter">
                    <custom-filter :data-source="statusFilterOptions" @update-filters="onFiltersUpdate" />
                </dx-item>
            </template>
        </local-grid>
    </div>
    <component :is="usersOfficialPopupSwitcher" />
    <component :is="usersPopupSwitcher" @save-click="showUsersPopup" />
    <component :is="userSubdivisionPopupSwitcher" />
    <component :is="allRolesPopupSwitcher" @items-event="receiveItems" />
    <component :is="roleAreasPopupSwitcher" />
    <component :is="massLocksPopupSwitcher" :users="selectedUsers" />
    <component :is="userLocksPopupSwitcher" />
</template>

<script setup>
import { ref, onMounted, computed, watch, onUnmounted } from 'vue';

import { DxItem } from 'devextreme-vue/data-grid';
import { DxButton } from 'devextreme-vue';
import DxDropDownButton from 'devextreme-vue/drop-down-button';

import LocalGrid from '@/components/local-grid.vue';

import CustomFilter from './custom-filter-form.vue';
import activeUserImg from '../../../../public/assets/active-user.svg';
import lockedUserImg from '../../../../public/assets/locked-user.svg';
import deletedUserImg from '../../../../public/assets/deleted-user.svg';

import usersLocalStore from './store';
import { dxUiConfirm, dxUiNotify } from '@/utils/dx-helper';

import UsersOfficialPopup from '@/views/administration/users/users-official-popup.vue';
import UsersPopup from '@/views/administration/users/users-popup.vue';
import UsersSubdivisionPopup from '@/views/administration/users/users-subdivision-popup.vue';
import RoleAreasPopup from '@/views/administration/users/role-areas-popup.vue';
import MassLocksPopup from '@/views/administration/users/mass-locks-popup.vue';
import UserLocksPopup from '@/views/administration/users/user-locks-popup.vue';

import AllRolesPopup from './all-roles-popup.vue';
import enviromentStore from '@/store/enviroment-data';

const { disableUiElement } = enviromentStore;

import usersStore from '@/store/administration/users';

const {
    usersState,
    setUserIds,
    setOfficialUserIds,
    fetchUserData,
    fetchOfficialUserData,
    getUsersList,
    restoreUser,
    deleteUser,
    filteredUsersList,
} = usersStore;

import rolesStore from '@/store/administration/roles';

const { rolesState, getRoleList } = rolesStore;

const { state, MODE, USER_STATUS, setUserRequestBody, clearUserRequestBody, clearLockFormData } =
    usersLocalStore;

getRoleList();
const statusFilter = ref([]);
const userGridRef = ref();
const gridDataSource = ref([]);
const gridInstance = ref(null);
const isSelectedItemKeys = ref(true);
const isCurrentUserStatusDeleted = ref(false);
const isCurrentUserStatusBlocked = ref(false);
const selectedUsers = ref();
const confirmPopupTitle = 'Подтвердите действие';

const usersOfficialPopupSwitcher = computed(() => state.officialPopupVisible ? UsersOfficialPopup : null);
const usersPopupSwitcher = computed(() => state.userCardPopupVisible ? UsersPopup : null);
const userSubdivisionPopupSwitcher = computed(() => state.subdivisionPopupVisible ? UsersSubdivisionPopup : null);
const allRolesPopupSwitcher = computed(() => state.usersRolePopupVisible ? AllRolesPopup : null);
const roleAreasPopupSwitcher = computed(() => state.roleAreasPopupVisible ? RoleAreasPopup : null);
const massLocksPopupSwitcher = computed(() => state.massLocksPopupVisible ? MassLocksPopup : null);
const userLocksPopupSwitcher = computed(() => state.userLocksPopupVisible ? UserLocksPopup : null);

onMounted(() => {
    gridInstance.value = userGridRef.value.gridInstance;
    gridInstance.value.on('contextMenuPreparing', onContextMenuPreparing);
    gridInstance.value.on('selectionChanged', onSelectionChanged);
    statusFilter.value = [USER_STATUS.ACTIVE, USER_STATUS.BLOCKED, USER_STATUS.EXPIRED];
    gridInstance.value.option('filterValue', enviromentStore.state.userGridFiltersValue);
});

onMounted(async () => {
    userGridRef.value?.gridInstance?.beginCustomLoading();
    await getUsersList();
    await enviromentStore.getAppList();
    userGridRef.value?.gridInstance?.endCustomLoading();
});

onUnmounted(() => {
    enviromentStore.state.userGridFiltersValue = gridInstance.value.option('filterValue');
});

const processUsersData = (usersData, rolesData) => {
    return usersData.map(user => {
        const matchedRoles = rolesData.filter(role => user.roles.includes(role.id));

        return {
            ...user,
            roles: matchedRoles.map(role => role.name),
        };
    });
};

const displayList = computed(() => {
    if (usersState.usersList && usersState.usersList.length > 0) {
        const filteredList = filteredUsersList(statusFilter.value);
        if (filteredList.length > 0) {
            return processUsersData(filteredList, rolesState.roleList);
        }
    }
    return [];
});

const createUserFromActiveDirectory = () => {
};

const onSelectionChanged = event => {
    isSelectedItemKeys.value = event.selectedRowKeys.length <= 0;
    isCurrentUserStatusDeleted.value = event.selectedRowsData.some(item => item.status === USER_STATUS.DELETED);
    isCurrentUserStatusBlocked.value = event.selectedRowsData.some(item => item.status === USER_STATUS.BLOCKED || item.status === USER_STATUS.EXPIRED);
};

const onFiltersUpdate = selectedFilters => {
    statusFilter.value = selectedFilters;
    for (const obj of statusFilterOptions) {
        if (selectedFilters.includes(obj.dataField)) {
            obj.value = true;
        } else {
            obj.value = false;
        }
    }
};

const statusFilterOptions = [
    { dataField: USER_STATUS.ACTIVE, label: 'Показывать активных', shortName: 'активных', value: true },
    { dataField: USER_STATUS.DELETED, label: 'Показывать архивированных', shortName: 'архивированных', value: false },
    {
        dataField: USER_STATUS.BLOCKED || USER_STATUS.EXPIRED,
        label: 'Показывать заблокированных',
        shortName: 'заблокированных',
        value: true,
    },
];

const updateGridData = async () => {
    await getUsersList();
    gridDataSource.value = displayList.value.filter(user => user.status === USER_STATUS.ACTIVE);
    gridInstance.value.deselectAll();
    gridInstance.value.option('focusedRowKey', null);
};

const onAddNewUser = async () => {
    stopWatchingAndInitConfirmedState();
    clearUserRequestBody();
    clearLockFormData();
    state.mode = MODE.CREATE;
    await getRoleList(null);
    state.currentTabIndex = 0;
    state.officialPopupVisible = true;
    startWatching();
};

const getMatchingApp = selectedItem => {
    const areasId = selectedItem?.areas?.map(item => item.app_id);
    const matchingApp = enviromentStore.state.appList
        .filter(app => areasId && areasId.includes(app.kod_app))
        .map(app => app.name_app)
        .join(', ');
    return matchingApp ? matchingApp : '';
};

const receiveItems = selectedItems => {
    const newItems = selectedItems?.map(selectedItem => ({
        ...selectedItem,
        name_app: getMatchingApp(selectedItem),
    }));

    const uniqueItems = state.userRequestBody.roles || [];
    newItems.forEach(newItem => {
        const existingIndex = uniqueItems.findIndex(existing => existing.id === newItem.id);
        existingIndex > -1 ? (uniqueItems[existingIndex] = newItem) : uniqueItems.push(newItem);
    });
    state.userRequestBody.roles = [...uniqueItems];
};

const initFilteredRoleUser = () => {
    const updatedItems = [];
    if (state.mode !== MODE.CREATE && usersState.userData.roles) {
        usersState.userData.roles.forEach(roleId => {
            const matchingItems = rolesState.roleList.filter(item => item.id === roleId);
            if (matchingItems.length > 0) {
                const matchedRoles = matchingItems.map(selectedItem => ({
                    ...selectedItem,
                    name_app: getMatchingApp(selectedItem),
                }));
                updatedItems.push(...matchedRoles);
            }
        });
        return (state.userRequestBody.roles = updatedItems);
    } else {
        return [];
    }
};

const mergeUserData = async () => {
    const userData = await fetchUserData();
    await setOfficialUserIds(usersState.userData.official_id);
    const officialUserData = await fetchOfficialUserData(userData.official_id);
    const user = { ...officialUserData, ...userData };
    return user;
};

const showUsersPopup = async event => {
    stopWatchingAndInitConfirmedState();
    const userData = event.row.key;
    setUserIds(userData);
    await getRoleList();
    const user = await mergeUserData();
    state.mode = MODE.UPDATE;
    clearUserRequestBody();
    state.deletedRoleKey = [];
    state.userCardPopupVisible = true;
    setUserRequestBody({ ...user, id: userData });
    state.userRequestBody.lock_reason = state.userRequestBody.lock_reason
        ? Array.isArray(state.userRequestBody.lock_reason)
            ? state.userRequestBody.lock_reason.map(reason => ({ id: new Date().getTime(), name: reason }))
            : [{ id: new Date().getTime(), name: state.userRequestBody.lock_reason }]
        : [];
    initFilteredRoleUser();

    setTimeout(() => {
        startWatching();
    }, 1000);
};

const showUserLocks = (event) => {
    state.userRequestBody.id = event.row.data.id;
    state.userRequestBody.fio = event.row.data.fio;
    state.userRequestBody.locks = [];
    state.userRequestBody.deleted_locks = [];
    state.userLocksPopupVisible = true;
};

const showMessageAndConfirm = (action, callBackFunction, actionArgs) => {
    dxUiConfirm(`Вы уверены, что хотите ${action} участника?`, confirmPopupTitle).then(confirmed => {
        if (confirmed) {
            callBackFunction(...actionArgs);
        }
    });
};

const showNotify = (action, successCount, errorCount) => {
    const type = errorCount > 0 ? 'warning' : 'success';
    const message = `Успешно ${action} ${successCount} пользователей, ${errorCount} пользователей не подошло под условие ${action}`;
    dxUiNotify(message, type);
};

const handleActionResponse = (response, action) => {
    const { resume } = response;
    showNotify(action, resume.successCount, resume.userFailedCount);
};

const massLockClick = () => {
    selectedUsers.value = gridInstance.value.getSelectedRowsData();
    state.massLocksPopupVisible = true;
};

const restoreUserAction = async userIds => {
    if (isSelectedItemKeys.value) {
        const response = await restoreUser(userIds);
        handleActionResponse(response, 'восстановления');
    }
};

const restoreSelectedUsers = userID => {
    isSelectedItemKeys.value = true;
    const usersToRestore = gridInstance.value.getSelectedRowKeys();
    const selectedUsers = usersToRestore.length === 0 ? [userID] : usersToRestore;
    showMessageAndConfirm('восстановить', () => restoreUserAction(selectedUsers), selectedUsers);
};

const deleteUserAction = async userIds => {
    if (isSelectedItemKeys.value) {
        const response = await deleteUser(userIds);
        handleActionResponse(response, 'удаления');
    }
};

const deleteSelectedUsers = userID => {
    isSelectedItemKeys.value = true;
    const usersToDelete = gridInstance.value.getSelectedRowKeys();
    const selectedUsers = usersToDelete.length === 0 ? [userID] : usersToDelete;
    showMessageAndConfirm('удалить', () => deleteUserAction(selectedUsers), selectedUsers);
};

const stopWatchingAndInitConfirmedState = () => {
    state.stopWatching && state.stopWatching();
    state.isClosingConfirmed = true;
    state.requestBodyHasNotChanged = true;
};

const startWatching = () => {
    state.stopWatching = watch(
        () => state.userRequestBody,
        () => {
            state.isClosingConfirmed = false;
            state.requestBodyHasNotChanged = false;
        },
        { deep: true },
    );
};

const onContextMenuPreparing = event => {
    if (!event.row) {
        return;
    }
    if (event.target === 'content') {
        if (!event.items) event.items = [];
        event.items.push(
            {
                text: 'Открыть карточку пользователя',
                onItemClick: () => showUsersPopup(event),
            },
            {
                text: 'Блокировки пользователя',
                onItemClick: () => showUserLocks(event),
            },
        );

        switch (event.row.data.status) {
            case USER_STATUS.ACTIVE:
                event.items.push(
                    {
                        text: 'Удалить',
                        onItemClick: () => deleteSelectedUsers(event.row.data.id),
                        disabled: disableUiElement({ id: 726 }),
                    },
                );
                break;
            case USER_STATUS.DELETED:
                event.items.push({
                    text: 'Восстановить',
                    onItemClick: () => restoreSelectedUsers(event.row.data.id),
                    disabled: disableUiElement({ id: 727 }),
                });
                break;
            case USER_STATUS.BLOCKED:
            case USER_STATUS.EXPIRED:
                event.items.push(
                    {
                        text: 'Удалить',
                        onItemClick: () => deleteSelectedUsers(event.row.data.id),
                        disabled: disableUiElement({ id: 726 }),
                    },
                );
                break;
        }
    }
};

const isSelectionMode = !disableUiElement({ id: 810 });

const meta = {
    keyExpr: 'id',
    wordWrapEnabled: true,
    scrollingMode: 'standart',
    focusedRowEnabled: true,
    allowSelectAll: isSelectionMode,
    selectionMode: isSelectionMode ? 'multiple' : 'none',
    columns: [
        {
            dataField: 'id',
            caption: 'ID',
            visible: false,
            dataType: 'number',
        },
        {
            dataField: 'user_login',
            caption: 'Логин',
            dataType: 'string',
        },
        {
            dataField: 'fio',
            caption: 'ФИО',
            sortOrder: 'asc',
            dataType: 'string',
        },
        {
            dataField: 'org_name',
            caption: 'Принадлежность к филиалу/организации',
            dataType: 'string',
        },
        {
            dataField: 'dep_name',
            caption: 'Подразделение',
            dataType: 'string',
        },
        {
            dataField: 'name_fun',
            caption: 'Должность',
            dataType: 'string',
        },
        {
            dataField: 'e_mail',
            caption: 'Электронная почта',
            dataType: 'string',
        },
        {
            dataField: 'phone',
            caption: 'Рабочий телефон',
            dataType: 'string',
        },
        {
            dataField: 'status',
            caption: 'Статус',
            cellTemplate: (cellElement, cellInfo) => {
                const imgSrc = cellInfo.value === USER_STATUS.ACTIVE
                    ? activeUserImg
                    : cellInfo.value === USER_STATUS.DELETED
                        ? deletedUserImg
                        : lockedUserImg;
                const imgElement = document.createElement('img');
                imgElement.src = imgSrc;
                imgElement.style.width = '15px';
                imgElement.style.height = '15px';
                cellElement.appendChild(imgElement);
            },
        },
        {
            dataField: 'roles',
            caption: 'Роли пользователя',
            dataType: 'string',
        },
    ],
};
</script>
